import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  page: {
    padding: `0 ${theme.shape.padding}px`,
  },
  section: {
    marginBottom: theme.shape.padding * 2,
  },
  sectionTitle: {
    fontSize: 25,
    fontWeight: "bold",
  },
  sectionInfoContainer: {
    width: "100%",
    display: "flex",
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  sectionInfoCard: {
    width: "30%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.shape.padding,
    justifyContent: "space-between",
    "& p": {
      margin: 0,
    },
  },
  alertText: {
    margin: 0,
  },
  rightBorder: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  sectionInfoCardTitle: {
    fontSize: 12,
  },
  sectionInfoCardText: {
    fontWeight: "bold",
  },
  manageInvoicesContainer: {
    display: "flex",
    marginBottom: 16,
    alignItems: "center",
    "& p": {
      margin: 0,
    },
  },
  manageButton: {
    marginLeft: theme.shape.padding,
  },
  productQuantity: {
    marginBottom: theme.shape.padding,
    marginRight: theme.shape.padding,
  },
  link: {
    fontSize: 14,
    cursor: "pointer",
    color: theme.palette.primary.main,
  },
  editCardText: {
    maxWidth: 150,
    cursor: "pointer",
    color: theme.palette.primary.main,
    marginLeft: theme.shape.padding * 2,
  },
  productsContainer: {
    display: "flex",
  },
  productSectionTitle: {
    fontSize: 20,
    marginBottom: 0,
    fontWeight: "bold",
    marginLeft: theme.shape.padding,
  },
  planOption: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: theme.shape.padding,
    justifyContent: "space-between",
    borderRadius: theme.shape.borderRadius,
    border: `2px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  namePriceContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: theme.shape.padding,
  },
  billingPeriod: {
    fontWeight: "bold",
  },
  price: {
    fontSize: 12,
    marginBottom: 0,
  },
  userHelperText: {
    fontSize: 12,
    paddingTop: theme.shape.padding,
  },
  checkContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.shape.padding,
  },
  currentCheck: {
    marginRight: 5,
    color: theme.palette.success.main,
  },
  currentText: {
    fontSize: 12,
    fontWeight: 500,
    marginBottom: 0,
    textTransform: "uppercase",
  },
  listItems: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  listItem: {
    display: "flex",
    fontSize: 14,
    "& p": {
      marginLeft: 10,
    },
  },
  certify: {
    display: "flex",
    alignItems: "center",
    "& p": {
      margin: 0,
      fontSize: 10,
      color: theme.palette.text.secondary,
    },
  },
  dialogActions: {
    justifyContent: "flex-start",
    padding: theme.shape.padding * 2,
    paddingTop: 0,
  },
  stepContainer: {
    display: "flex",
  },
  numberContainer: {
    width: 20,
    height: 20,
    borderRadius: 10,
    marginRight: theme.shape.padding,
    backgroundColor: theme.palette.grey[600],
    textAlign: "center",
    "& p": {
      margin: 0,
      color: theme.palette.common.white,
    },
  },
  divider: {
    margin: `${theme.shape.padding}px 0`,
  },
  newPlanContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between",
  },
  newPlanPrimaryContent: {
    padding: `15px 30px`,
  },
  planNameText: {
    fontSize: 18,
    fontWeight: "bold",
    fontFamily: "Prompt",
    marginBottom: theme.shape.padding,
  },
  descriptionText: {
    fontSize: 14,
    fontWeight: "bold",
  },
  detailTextContainer: {
    display: "flex",
    marginBottom: 5,
    alignItems: "center",
    marginLeft: -theme.shape.padding,
  },
  detailText: {
    fontSize: 14,
    marginBottom: 0,
  },
  checkIcon: {
    fontSize: 13,
    color: theme.palette.primary.main,
  },
  ctaButton: {
    height: 40,
    fontSize: 15,
    fontWeight: "bold",
  },
  bonusMaterialContainer: {
    color: "black",
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    padding: theme.shape.padding,
    marginTop: theme.shape.padding,
    borderTop: "1px solid #cddaf2",
    background: "radial-gradient(white, #dae4f8)",
    "& p": {
      fontSize: 14,
    },
  },
  bonusMaterialTitle: {
    fontWeight: "bold",
  },
  footerContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "& p": {
      margin: 0,
      fontSize: 14,
    },
  },
  infoContainer: {
    display: "flex",
    alignItems: "center",
    margin: `${theme.shape.padding}px 0`,
    "& p": {
      marginLeft: 5,
      fontWeight: 500,
    },
  },
  ctaContainer: {
    display: "flex",
    alignItems: "center",
    "& p": {
      marginRight: theme.shape.padding * 2,
    },
  },
}));
